<template>
    <div v-if="this.values_arttype.length>0" class="works-filter__block works-filter__block-list filter-arttype">
        <!--<div class="works-filter__block-title">{{ $t("message.ArtTypes") }}</div>-->
        <div class="list-container list-container__arttype">
          <!--<label v-for="val in this.values_arttype" :class="[{'active': arttype[val.value]}, (val.cnt === '0') ? 'disabled-type' : '']">-->
          <label v-for="val in this.values_arttype" :class="[label_class, {'active': arttype[val.value]}]">
            <span class="checkbox">
                <input type="checkbox"  v-model="arttype[val.value]" @change="change_val_arttype(val)">
            </span>
            {{val.label}}
          </label>
        </div>
    </div>
</template>

<script>
  import FilterArttypeMix from "../../../../../components/list/filter/FilterArttypeMix";

  export default {
    name      : 'filter-artists-arttype',
    props: {
      label_class: {type: String, default:''},
    },
    mixins: [FilterArttypeMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/filter/FilterArtistsArttype.vue